export const DB_KEY = 'espacero_listings_db';
export const USER_KEY = 'espacero_user_profile_db';
export const FAVORITES_KEY = 'espacero_favorites_db';
export const REVIEWS_KEY = 'espacero_reviews_db';
export const LISTINGS_KEY = 'espacero_listings_db';
export const CATEGORIES_KEY = 'espacero_categories_db';
export const VENDORS_KEY = 'espacero_vendors_db';
